
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_1h6fg_93",
  "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_1h6fg_93",
  "resizer": "awsui_resizer_x7peu_1h6fg_98",
  "resizer-active": "awsui_resizer-active_x7peu_1h6fg_114",
  "has-focus": "awsui_has-focus_x7peu_1h6fg_123",
  "tracker": "awsui_tracker_x7peu_1h6fg_146"
};
  